import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Link } from 'react-router-dom';
import { propBool } from '../../../helpers/custom-prop-types';
const HeaderHumMenuList = (props) => {
    const { isShowProffitSearch } = props;
    return (_jsxs("ul", Object.assign({ className: 'header-nav' }, { children: [_jsx("li", { children: _jsx(Link, Object.assign({ to: '/mypage' }, { children: "\u30DE\u30A4\u30DA\u30FC\u30B8" })) }), isShowProffitSearch && (_jsx("li", { children: _jsx(Link, Object.assign({ to: '/proffit_search' }, { children: "PROFFIT SEARCH" })) }))] })));
};
HeaderHumMenuList.propTypes = {
    isShowProffitSearch: propBool().isRequired,
};
export default HeaderHumMenuList;
